import React, { useEffect, useState } from "react";
import useStatusStore from "../../store/statusStore";
import { getSeasonKey, SEASONS } from "../../config/hours";
import { HoursList } from "../site/Blocks";

// Öffnungszeiten mit Umschalter Winter/Sommer, aktuelle Saison vorausgewählt.
const OpeningHours = () => {
    const [selectedSeason, setSelectedSeason] = useState(getSeasonKey());
    const { specialOpening, fetchSpecialOpening } = useStatusStore();

    useEffect(() => {
        fetchSpecialOpening();
    }, [fetchSpecialOpening]);

    return (
        <div>
            {specialOpening && specialOpening.active && (
                <div className="mb-8 max-w-[480px] border border-erfolg px-5 py-3.5 text-sm leading-normal">
                    <strong className="font-semibold">Heute geöffnet.</strong>{" "}
                    {specialOpening.note || "Sonderöffnungszeiten – die regulären Öffnungszeiten entfallen."}
                </div>
            )}
            <div role="tablist" aria-label="Saison" className="reveal mb-8 flex flex-wrap gap-x-7 gap-y-3">
                {["winter", "summer"].map((key) => {
                    const selected = key === selectedSeason;
                    return (
                        <button
                            key={key}
                            role="tab"
                            type="button"
                            aria-selected={selected}
                            onClick={() => setSelectedSeason(key)}
                            className={`whitespace-nowrap border-b bg-transparent pb-1.5 text-[13px] font-medium uppercase tracking-[.08em] ${
                                selected ? "border-forest text-forest" : "border-transparent text-forest/70"
                            }`}
                        >
                            {SEASONS[key].label}
                        </button>
                    );
                })}
            </div>
            <div role="tabpanel" className="reveal d1">
                <HoursList
                    season={SEASONS[selectedSeason]}
                    className="!max-w-[480px] !gap-y-4 !border-forest !text-[17px]"
                />
            </div>
        </div>
    );
};

export default OpeningHours;
